import { render, staticRenderFns } from "./DSourcePreview.vue?vue&type=template&id=82e3e876&scoped=true&"
import script from "./DSourcePreview.vue?vue&type=script&lang=js&"
export * from "./DSourcePreview.vue?vue&type=script&lang=js&"
import style0 from "./DSourcePreview.vue?vue&type=style&index=0&id=82e3e876&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82e3e876",
  null
  
)

export default component.exports